import format from "date-fns/format";

type TDate = Date | string;
export function isWeekend(date: TDate = new Date()) {
  const day = format(new Date(date), "cccc");
  return (
    day === "суббота" ||
    day === "Суббота" ||
    day === "Saturday" ||
    day === "воскресенье" ||
    day === "Воскресенье" ||
    day === "Sunday"
  );
}
